module.exports = __webpack_public_path__ + "static/media/YF97_9.8429e9f7.jpg";